import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import {
  DeleteSection,
  SanctionSection,
  type DetailMode,
} from './creator-detail-sections';
import {
  AppealSection,
  UserDeleteSection,
} from './creator-detail-fase-b-sections';
import {
  HardDeleteSection,
  RestoreSection,
} from './creator-lifecycle-sections';
import { AlertSection } from './creator-alert-section';

type Props = {
  creator: Creator;
  mode: DetailMode;
  setMode: (m: DetailMode) => void;
  onClose: () => void;
};

const SECTIONS: Record<
  Exclude<DetailMode, 'view' | 'edit'>,
  (p: Omit<Props, 'mode'>) => ReactNode
> = {
  delete: (p) => <DeleteSection {...p} />,
  restore: (p) => <RestoreSection {...p} />,
  'hard-delete': (p) => <HardDeleteSection {...p} />,
  sanction: (p) => <SanctionSection {...p} />,
  alert: (p) => <AlertSection {...p} />,
  appeal: (p) => <AppealSection {...p} />,
  'user-delete': (p) => <UserDeleteSection {...p} />,
};

export function ModeSection(p: Props): ReactNode {
  if (p.mode === 'view' || p.mode === 'edit') return null;
  const render = SECTIONS[p.mode];
  return render({
    creator: p.creator,
    setMode: p.setMode,
    onClose: p.onClose,
  });
}
